import { ref, computed } from "vue";
import router from "@/app/router";
import { defineStore } from "pinia";
import {
        EnumFlowType,
        copySharedProperties,
        IContractData,
        IExposureData,
        IIdentificationData,
        IPreapproved,
        ICustomerData,
        ICalculationData,
        IEmploymentData,
        ISisbonData,
        IProcessData,
        IWebOrderData,
        createNavigationSteps,
        createExposureData,
        createContractData,
        createPreapprovedData,
        createCustomerData,
        createCalculationData,
        createEmploymentData,
        createSisbonData,
        createIdentificationData,
        createProcessData,
        createWebOrderData,
        IOrderEndComponentObject,
        createOrderEndComponentData,
        EnumNotificationType,
        INavigationSteps
    } from "nlb-buy-go-library-v2";
import { commClient } from "fw4-library";

interface IContractCreateStore {
    ProcessData: IProcessData;
    WebOrderData: IWebOrderData;
    CustomerData: ICustomerData;
    EmploymentData: IEmploymentData;
    ContractData: IContractData;
    CalculationData: ICalculationData;
    PreapprovedData: IPreapproved;
    ExposureData: IExposureData;
    IdentificationData: IIdentificationData;
    SisbonData: ISisbonData;
    OrderEndData: IOrderEndComponentObject;
    NavigationSteps: INavigationSteps;
};

export const useWebOrderStore = defineStore("webOrderStore", () => {
    const AppState = ref<IContractCreateStore>({
        ProcessData: createProcessData(),
        WebOrderData: createWebOrderData(),
        CustomerData: createCustomerData(),
        EmploymentData: createEmploymentData(),
        ContractData: createContractData(),
        CalculationData: createCalculationData(),
        PreapprovedData: createPreapprovedData(),
        IdentificationData: createIdentificationData(),
        ExposureData: createExposureData(),
        SisbonData: createSisbonData(),
        OrderEndData: createOrderEndComponentData(),
        NavigationSteps: createNavigationSteps(),
    });

    async function loadOrderData(orderToken: string) {
        AppState.value.WebOrderData.orderToken = orderToken;
        console.log("Setting orderToken: ", orderToken);

        const Message: any = await commClient.executeMethodAsync("sw.WebOrderDataLoadNewFlow",{
            OrderToken: AppState.value.WebOrderData.orderToken
        });
        if (Message) {
            if(Message.Success){
                copySharedProperties(AppState.value.ProcessData, Message);
                copySharedProperties(AppState.value.WebOrderData, Message);
                copySharedProperties(AppState.value.CustomerData, Message);
                copySharedProperties(AppState.value.ContractData, Message);
                copySharedProperties(AppState.value.ExposureData, Message);
                copySharedProperties(AppState.value.SisbonData, Message);
                copySharedProperties(AppState.value.CalculationData, Message);
                copySharedProperties(AppState.value.IdentificationData, Message);

                router.push({name: "WebOrderStep1", params: {id: orderToken}});
            } else {
                AppState.value.OrderEndData.title = "OrderEnd.TitleFail";
                AppState.value.OrderEndData.notificationType = EnumNotificationType.Error;
                AppState.value.OrderEndData.belowNotificationHtml = `Pogodba s tem naročilom že obstaja.`;
                await router.push({ name: "WebOrderEnd", params: { id: orderToken }});

            }
        } else {
            AppState.value.OrderEndData.title = "OrderEnd.TitleFail";
            AppState.value.OrderEndData.notificationType = EnumNotificationType.Error;
            AppState.value.OrderEndData.belowNotificationHtml = `Ne najdemo vašega naročila.`;
            await router.push({name: "WebOrderEnd", params: { id: orderToken } });
        }                
    };

    function reset() {
        AppState.value.ProcessData = createProcessData();
        AppState.value.WebOrderData = createWebOrderData();
        AppState.value.CustomerData = createCustomerData();
        AppState.value.EmploymentData = createEmploymentData();
        AppState.value.ContractData = createContractData();
        AppState.value.CalculationData = createCalculationData();
        AppState.value.PreapprovedData = createPreapprovedData();
        AppState.value.IdentificationData = createIdentificationData();
        AppState.value.ExposureData = createExposureData();
        AppState.value.SisbonData = createSisbonData();
    };

    const isPreapprovedValid = computed(() => {
        return (
            AppState.value.PreapprovedData.isPreapproved === true &&
            AppState.value.PreapprovedData.preapprovedCreditAmount >= AppState.value.ContractData.creditAmount! &&
            AppState.value.PreapprovedData.preapprovedInstallmentAmount >= AppState.value.CalculationData.installmentValNoCost
        );
    });

    return {
        AppState,
        reset,
        loadOrderData,
        isPreapprovedValid
    };
});
